export var GuidelineGrouping;
(function (GuidelineGrouping) {
    GuidelineGrouping["CLASSIFICATION"] = "CLASSIFICATION";
    GuidelineGrouping["PROGRAM"] = "PROGRAM";
    GuidelineGrouping["REPORTER"] = "REPORTER";
    GuidelineGrouping["TEAM"] = "TEAM";
    GuidelineGrouping["VEHICLE"] = "VEHICLE";
})(GuidelineGrouping || (GuidelineGrouping = {}));
